import { api } from './client'
import { withCustomerIds } from './params'

export function fetchBackupSettings() {
  return api.get('/backup/settings').then((r) => r.data)
}

export function updateBackupSettings(body) {
  return api.put('/backup/settings', body).then((r) => r.data)
}

export function fetchBackupSummary(customerIds = []) {
  return api
    .get('/backup/summary', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}

export function fetchBackupHosts(customerIds = []) {
  return api
    .get('/backup/hosts', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}
